import { PageId } from 'constants/pages'
import { isEmpty } from 'lodash'
import { PaymentSystem } from 'nove8/constants/payment'
import { TStep } from 'nove8/types'
import { StatesConfig } from 'xstate'
import { useZustandGlobalLocalStore } from 'zustandGlobalLocalStore'
import { useZustandSessionStore } from 'zustandGlobalSessionStore'
import { useZustandGlobalStore } from 'zustandGlobalStore'
import { getHasBasicSubscription } from '../../../helpers/getHasBasicSubscription'

const getHasEmail = () => !!useZustandGlobalStore.getState().lead?.email
const getHasSubscription = () =>
  getHasBasicSubscription(
    useZustandGlobalStore.getState().lead?.subscriptions || null,
  )
const getHasAccount = () =>
  !!useZustandGlobalStore.getState().lead?.firebaseToken
const getHasAnswers = () =>
  !isEmpty(
    useZustandSessionStore.getState().userAnswers ||
      useZustandGlobalStore.getState().lead?.quizzes ||
      null,
  )

const isPaypalPayment = () =>
  ((useZustandGlobalStore.getState().lead?.subscriptions?.[0]
    ?.paymentSystemType as unknown) as PaymentSystem) === PaymentSystem.PAYPAL

export const getXStateConfigWoofzPpday70 = (
  pages: TStep[],
): StatesConfig<any, any, any> => ({
  initial: {
    // Pay attention to the order of the conditions!
    always: [
      // Cover case when page was reloaded or connection was lost
      // during the purchase polling
      {
        cond: (): boolean => !!useZustandGlobalLocalStore.getState().purchaseId,
        target:
          useZustandGlobalLocalStore.getState().purchasePageId ||
          pages[0].pageId,
      },
      // Do not redirect users to the next breakpoint before email page
      {
        cond: (): boolean => {
          const hasEmail = getHasEmail()
          const hasSubscription = getHasSubscription()
          const hasAccount = getHasAccount()
          const hasAnswers = getHasAnswers()
          return !hasEmail && !hasSubscription && !hasAccount && hasAnswers
        },
        target:
          pages.find((dynamicPage) => {
            const pageIdFromUrl =
              window.location.pathname.split('/').pop() || ''
            return pageIdFromUrl === dynamicPage.pageId
          })?.pageId || pages[0].pageId,
      },
      {
        cond: (): boolean => getHasAccount(),
        target: PageId.DOWNLOAD_PPDAY_70,
      },
      {
        cond: (): boolean => getHasSubscription(),
        target: PageId.ACCOUNT_NOVE8,
      },
      {
        cond: (): boolean => getHasEmail(),
        target: PageId.SUBSCRIPTIONS_PPDAY_70_N,
      },
      {
        target: pages[0].pageId, // Always transition to first page as fallback
      },
    ],
  },
  ...pages.reduce(
    (acc, page, index) => ({
      ...acc,
      [page.pageId]: {
        on: {
          NEXT_FLOW_STEP: {
            target: pages[index + 1]?.pageId,
          },
          SKIP_ONE_STEP: {
            target: pages[index + 2]?.pageId,
          },
          PREVIOUS_FLOW_STEP: {
            target:
              index - 1 >= 0 ? pages[index - 1].pageId : pages[index].pageId,
          },
          SKIP_ONE_STEP_BACK: {
            target:
              index - 2 >= 0 ? pages[index - 2].pageId : pages[index].pageId,
          },
          ...(page.pageId === PageId.SUBSCRIPTIONS_PPDAY_70_N && {
            NEXT_FLOW_STEP: [
              {
                cond: isPaypalPayment,
                target: PageId.ACCOUNT_NOVE8,
              },
              {
                target: PageId.CHAT_UPSELL_PPDAY_70,
              },
            ],
          }),
          ...(page.pageId === PageId.CHAT_UPSELL_PPDAY_70 && {
            NEXT_FLOW_STEP: PageId.UPSELL_PPDAY_70,
          }),
          ...(page.pageId === PageId.UPSELL_PPDAY_70 && {
            NEXT_FLOW_STEP: PageId.ACCOUNT_NOVE8,
          }),
        },
      },
    }),
    {},
  ),
  [PageId.ACCOUNT_NOVE8]: {
    on: {
      NEXT_FLOW_STEP: PageId.DOWNLOAD_PPDAY_70,
    },
  },
  [PageId.DOWNLOAD_PPDAY_70]: {
    type: 'final',
  },
})
